/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Rule_NeverInputs */

const en_pb_rule_never = /** @type {(inputs: Pb_Rule_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never`)
};

const id_pb_rule_never = /** @type {(inputs: Pb_Rule_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jangan pernah`)
};

/**
* | output |
* | --- |
* | "Never" |
*
* @param {Pb_Rule_NeverInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_rule_never = /** @type {((inputs?: Pb_Rule_NeverInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Rule_NeverInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_rule_never(inputs)
	return en_pb_rule_never(inputs)
});